import { Box, Text, useColorModeValue } from "@chakra-ui/react";

import { useAppStore } from "../store";

/**
 * Debug mode indicator that appears when debug mode is active
 * This can be placed in the Layout component to be visible on all pages
 */
const DebugModeDisplay = () => {
  const debugMode = useAppStore((state) => state.debugMode);

  // Color mode values
  const bgColor = useColorModeValue("rgba(0, 0, 0, 0.7)", "rgba(255, 255, 255, 0.7)");
  const textColor = useColorModeValue("white", "black");

  if (!debugMode) {
    return null;
  }

  return (
    <Box
      position="fixed"
      bottom="10px"
      right="10px"
      backgroundColor={bgColor}
      color={textColor}
      padding="5px 10px"
      borderRadius="4px"
      zIndex={9999}
      fontSize="xs"
      boxShadow="md"
      pointerEvents="none"
    >
      <Text fontWeight="bold">DEBUG MODE</Text>
    </Box>
  );
};

export default DebugModeDisplay;
